import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/lanhu_shouye'
  },
  {
    path: '/lanhu_jigouyulishi',
    name: 'lanhu_jigouyulishi',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_jigouyulishi/index.vue'),
    meta: { title: '机构与历史 - 新闻所历史' }
  },
  {
    path: '/lanhu_xuenihongzhao',
    name: 'lanhu_xuenihongzhao',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_xuenihongzhao/index.vue'),
    meta: { title: '珍贵历史图片资料 - 领导关怀 - 机构与历史 - 新闻所历史' }
  },
  {
    path: '/lanhu_mingchengbiangeng',
    name: 'lanhu_mingchengbiangeng',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_mingchengbiangeng/index.vue'),
    meta: { title: '名称变更 - 建制沿革 - 机构与历史 - 新闻所历史' }
  },
  {
    path: '/lanhu_bangongdidianbiangeng',
    name: 'lanhu_bangongdidianbiangeng',
    component: () =>
      import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_bangongdidianbiangeng/index.vue'),
    meta: { title: '办公地点变更 - 建制沿革 - 机构与历史 - 新闻所历史' }
  },
  {
    path: '/lanhu_jigoushezhi',
    name: 'lanhu_jigoushezhi',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_jigoushezhi/index.vue'),
    meta: { title: '机构设置 - 建制沿革 - 机构与历史 - 新闻所历史' }
  },
  {
    path: '/lanhu_xuekeyukeyan',
    name: 'lanhu_xuekeyukeyan',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_xuekeyukeyan/index.vue'),
    meta: { title: '学科与科研 - 新闻所历史' }
  },
  {
    path: '/lanhu_zhengwenyexueshuchengguo',
    name: 'lanhu_zhengwenyexueshuchengguo',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_zhengwenyexueshuchengguo/index.vue'
      ),
    meta: { title: '学术成果掠影 - 新闻所历史' }
  },
  {
    path: '/lanhu_keyanchengguohuojiang',
    name: 'lanhu_keyanchengguohuojiang',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_keyanchengguohuojiang/index.vue'
      ),
    meta: { title: '新闻与传播研究所科研成果获奖情况 - 新闻所历史' }
  },
  {
    path: '/lanhu_zhongguochuanboxuedahui',
    name: 'lanhu_zhongguochuanboxuedahui',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_zhongguochuanboxuedahui/index.vue'
      ),
    meta: { title: '中国传播学大会 - 新闻所历史' }
  },
  {
    path: '/lanhu_xinmeitilanpishu',
    name: 'lanhu_xinmeitilanpishu',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xinmeitilanpishu/index.vue'),
    meta: { title: '新媒体蓝皮书发布暨新媒体发展研讨会 - 新闻所历史' }
  },
  {
    path: '/lanhu_guoneixueshujiaoliu',
    name: 'lanhu_guoneixueshujiaoliu',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_guoneixueshujiaoliu/index.vue'),
    meta: { title: '国内学术交流 - 新闻所历史' }
  },
  {
    path: '/lanhu_diaoyanhuodong',
    name: 'lanhu_diaoyanhuodong',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_diaoyanhuodong/index.vue'),
    meta: { title: '调研活动 - 新闻所历史' }
  },
  {
    path: '/lanhu_guojixueshujiaoliu',
    name: 'lanhu_guojixueshujiaoliu',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_guojixueshujiaoliu/index.vue'),
    meta: { title: '国际学术交流 - 新闻所历史' }
  },
  {
    path: '/lanhu_shouzhongyanjiu',
    name: 'lanhu_shouzhongyanjiu',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_shouzhongyanjiu/index.vue'),
    meta: { title: '受众研究学术研讨会 - 新闻所历史' }
  },
  {
    path: '/lanhu_xinwenshiqingnian',
    name: 'lanhu_xinwenshiqingnian',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xinwenshiqingnian/index.vue'),
    meta: { title: '新闻史青年学者论坛 - 新闻所历史' }
  },
  {
    path: '/lanhu_yuqingdiaocha',
    name: 'lanhu_yuqingdiaocha',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_yuqingdiaocha/index.vue'),
    meta: { title: '舆情调查 - 新闻所历史' }
  },
  {
    path: '/lanhu_xueshushalong',
    name: 'lanhu_xueshushalong',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xueshushalong/index.vue'),
    meta: { title: '学术沙龙活动 - 新闻所历史' }
  },
  {
    path: '/lanhu_yanjiuzhongxin',
    name: 'lanhu_yanjiuzhongxin',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_yanjiuzhongxin/index.vue'),
    meta: { title: '研究中心活动 - 新闻所历史' }
  },
  {
    path: '/lanhu_xueshupingjia',
    name: 'lanhu_xueshupingjia',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xueshupingjia/index.vue'),
    meta: { title: '学术评价 - 新闻所历史' }
  },
  {
    path: '/lanhu_chuangxingongcheng',
    name: 'lanhu_chuangxingongcheng',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_chuangxingongcheng/index.vue'),
    meta: { title: '创新工程 - 新闻所历史' }
  },
  {
    path: '/lanhu_chuanboyupingtai',
    name: 'lanhu_chuanboyupingtai',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_chuanboyupingtai/index.vue'),
    meta: { title: '传播与平台 - 新闻所历史' }
  },
  {
    path: '/lanhu_jiaoyuyurencai',
    name: 'lanhu_jiaoyuyurencai',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_jiaoyuyurencai/index.vue'),
    meta: { title: '教育与人才 - 新闻所历史' }
  },
  {
    path: '/lanhu_keyanbaozhang',
    name: 'lanhu_keyanbaozhang',
    component: () => import(/* webpackChunkName: "secondary-pages" */ '../views/lanhu_keyanbaozhang/index.vue'),
    meta: { title: '科研保障 - 新闻所历史' }
  },
  {
    path: '/lanhu_renshiminglu',
    name: 'lanhu_renshiminglu',
    redirect: '/lanhu_lirensuolingdao',
    meta: { title: '人事名录 - 新闻所历史' }
  },
  {
    path: '/lanhu_yanjiushengjiaoyu',
    name: 'lanhu_yanjiushengjiaoyu',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_yanjiushengjiaoyu/index.vue'),
    meta: { title: '研究生教育 - 新闻所历史' }
  },
  {
    path: '/lanhu_lunwendabian',
    name: 'lanhu_lunwendabian',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_lunwendabian/index.vue'),
    meta: { title: '论文答辩 - 新闻所历史' }
  },
  {
    path: '/lanhu_fulu',
    name: 'lanhu_fulu',
    component: () => import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_fulu/index.vue'),
    meta: { title: '附录 - 新闻所历史' }
  },
  {
    path: '/lanhu_dangjiangongzuo',
    name: 'lanhu_dangjiangongzuo',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_dangjiangongzuo/index.vue'),
    meta: { title: '党建工作 - 新闻所历史' }
  },
  {
    path: '/lanhu_xingzhengguanligongzuo',
    name: 'lanhu_xingzhengguanligongzuo',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xingzhengguanligongzuo/index.vue'
      ),
    meta: { title: '行政管理工作 - 新闻所历史' }
  },
  {
    path: '/lanhu_lituixiuganbugongzuo',
    name: 'lanhu_lituixiuganbugongzuo',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_lituixiuganbugongzuo/index.vue'),
    meta: { title: '离退休干部工作 - 新闻所历史' }
  },
  {
    path: '/lanhu_jitiguoshengri',
    name: 'lanhu_jitiguoshengri',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_jitiguoshengri/index.vue'),
    meta: { title: '集体过生日 - 新闻所历史' }
  },
  {
    path: '/lanhu_zhigongjitihuodong',
    name: 'lanhu_zhigongjitihuodong',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_zhigongjitihuodong/index.vue'),
    meta: { title: '职工集体活动 - 新闻所历史' }
  },
  {
    path: '/lanhu_lirensuolingdao',
    name: 'lanhu_lirensuolingdao',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_lirensuolingdao/index.vue'),
    meta: { title: '新闻与传播研究所历任所领导 - 新闻所历史' }
  },
  {
    path: '/lanhu_jigoulishiyange',
    name: 'lanhu_jigoulishiyange',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_jigoulishiyange/index.vue'),
    meta: { title: '新闻与传播研究所机构历史沿革 - 新闻所历史' }
  },
  {
    path: '/lanhu_renshirenyuanminglu',
    name: 'lanhu_renshirenyuanminglu',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_renshirenyuanminglu/index.vue'),
    meta: { title: '新闻与传播研究所人员名录 - 新闻所历史' }
  },
  {
    path: '/lanhu_chuanbopingtai',
    name: 'lanhu_chuanbopingtai',
    component: () => import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_chuanbopingtai/index.vue'),
    meta: { title: '传播平台 - 新闻所历史' }
  },
  {
    path: '/lanhu_xinwenyuchuanboyanjiu',
    name: 'lanhu_xinwenyuchuanboyanjiu',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xinwenyuchuanboyanjiu/index.vue'),
    meta: { title: '《新闻与传播研究》 - 新闻所历史' }
  },
  {
    path: '/lanhu_zhongguoxinwennianjian',
    name: 'lanhu_zhongguoxinwennianjian',
    component: () =>
      import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_zhongguoxinwennianjian/index.vue'),
    meta: { title: '《中国新闻年鉴》 - 新闻所历史' }
  },
  {
    path: '/lanhu_zhongguoxinwenchuanboxuenianjian',
    name: 'lanhu_zhongguoxinwenchuanboxuenianjian',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_zhongguoxinwenchuanboxuenianjian/index.vue'
      ),
    meta: { title: '《中国新闻传播学年鉴》 - 新闻所历史' }
  },
  {
    path: '/lanhu_zhixuelihuaxilie',
    name: 'lanhu_zhixuelihuaxilie',
    component: () => import(/* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_zhixuelihuaxilie/index.vue'),
    meta: { title: '《治学例话》系列 - 新闻所历史' }
  },
  {
    path: '/lanhu_xinwenxuechuanboxuewenzhai',
    name: 'lanhu_xinwenxuechuanboxuewenzhai',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xinwenxuechuanboxuewenzhai/index.vue'
      ),
    meta: { title: '《新闻学传播学文摘》 - 新闻所历史' }
  },
  {
    path: '/lanhu_xinwenyuchuanboyanjiuwang',
    name: 'lanhu_xinwenyuchuanboyanjiuwang',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xinwenyuchuanboyanjiuwang/index.vue'
      ),
    meta: { title: '新闻与传播研究网 - 新闻所历史' }
  },
  {
    path: '/lanhu_xinwenyuchuanboxueshuqianyan',
    name: 'lanhu_xinwenyuchuanboxueshuqianyan',
    component: () =>
      import(
        /* webpackChunkName: "academic-achievement-page" */ '../views/lanhu_xinwenyuchuanboxueshuqianyan/index.vue'
      ),
    meta: { title: '“新闻与传播学术前沿”微信公号 - 新闻所历史' }
  },
  {
    path: '/lanhu_shouye',
    name: 'lanhu_shouye',
    component: () => import(/* webpackChunkName: "home-page" */ '../views/lanhu_shouye/index.vue'),
    meta: { title: '社科网首页 - 新闻所历史' }
  },
  // ===== New web-native layout versions (prototype) =====
  {
    path: '/new/lanhu_xinwenyuchuanboyanjiu',
    name: 'new_lanhu_xinwenyuchuanboyanjiu',
    component: () =>
      import(/* webpackChunkName: "new-web-pages" */ '../views/new/lanhu_xinwenyuchuanboyanjiu/index.vue'),
    meta: { title: '【新版】《新闻与传播研究》 - 新闻所历史' }
  },
  {
    path: '/new/lanhu_zhongguoxinwennianjian',
    name: 'new_lanhu_zhongguoxinwennianjian',
    component: () =>
      import(/* webpackChunkName: "new-web-pages" */ '../views/new/lanhu_zhongguoxinwennianjian/index.vue'),
    meta: { title: '【新版】《中国新闻年鉴》 - 新闻所历史' }
  },
  {
    path: '/new/lanhu_zhongguoxinwenchuanboxuenianjian',
    name: 'new_lanhu_zhongguoxinwenchuanboxuenianjian',
    component: () =>
      import(
        /* webpackChunkName: "new-web-pages" */ '../views/new/lanhu_zhongguoxinwenchuanboxuenianjian/index.vue'
      ),
    meta: { title: '【新版】《中国新闻传播学年鉴》 - 新闻所历史' }
  },
  {
    path: '/new/lanhu_zhixuelihuaxilie',
    name: 'new_lanhu_zhixuelihuaxilie',
    component: () => import(/* webpackChunkName: "new-web-pages" */ '../views/new/lanhu_zhixuelihuaxilie/index.vue'),
    meta: { title: '【新版】《治学例话》系列 - 新闻所历史' }
  },
  {
    path: '/new/lanhu_xinwenxuechuanboxuewenzhai',
    name: 'new_lanhu_xinwenxuechuanboxuewenzhai',
    component: () =>
      import(/* webpackChunkName: "new-web-pages" */ '../views/new/lanhu_xinwenxuechuanboxuewenzhai/index.vue'),
    meta: { title: '【新版】《新闻学传播学文摘》 - 新闻所历史' }
  },
  {
    path: '/new/lanhu_xinwenyuchuanboyanjiuwang',
    name: 'new_lanhu_xinwenyuchuanboyanjiuwang',
    component: () =>
      import(/* webpackChunkName: "new-web-pages" */ '../views/new/lanhu_xinwenyuchuanboyanjiuwang/index.vue'),
    meta: { title: '【新版】新闻与传播研究网 - 新闻所历史' }
  },
  {
    path: '/new/lanhu_xinwenyuchuanboxueshuqianyan',
    name: 'new_lanhu_xinwenyuchuanboxueshuqianyan',
    component: () =>
      import(/* webpackChunkName: "new-web-pages" */ '../views/new/lanhu_xinwenyuchuanboxueshuqianyan/index.vue'),
    meta: { title: '【新版】“新闻与传播学术前沿”微信公号 - 新闻所历史' }
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return false;
  }
});

export default router;
